import { Checkable } from './Checkable';
import { CheckableTrigger } from './CheckableTrigger';
import { CheckableInput } from './CheckableInput';

Checkable.Trigger = CheckableTrigger;
Checkable.Input = CheckableInput;

export default Checkable;